import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import Translation from '@swf/components/Translation/Translation';
import { ClubPlayerStatus } from '@swf/core/types/Poker';
import { PKR_LOADERS, PKR_USER_ROLE_TRANSLATIONS, Table, useHomeGamesWidget } from '@swf/poker';

import styles from '../Members.scss';
import { columnsNonMembers } from '../utils';

import ActionButtons from './ActionButtons';

const Pending: React.FC = () => {
  const { clubId } = useParams<{ clubId: string }>();
  const { widgetSelect, widgetDispatch } = useHomeGamesWidget();
  const loadingState = useSelector(widgetSelect.loading);
  const members = useSelector(widgetSelect.clubMembers);
  const loading = loadingState[PKR_LOADERS.clubMembers];

  useEffect(() => {
    widgetDispatch.fetchClubMembers({
      clubId,
      statuses: ['HG_MEMBERSHIP_STATUS_APPLIED']
    });

    return () => {
      widgetDispatch.setClubMembers({ response: [] });
      widgetDispatch.setLoading({ isLoading: true, loaderName: PKR_LOADERS.clubInfo });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clubId]);

  const transformedMembers = useMemo(
    () =>
      members
        .filter(({ membershipStatus }) => membershipStatus === ClubPlayerStatus.APPLIED)
        .map((member) => ({
          ...member,
          // eslint-disable-next-line react/jsx-no-useless-fragment
          enrolled: <></>,
          role: <Translation {...PKR_USER_ROLE_TRANSLATIONS[member.memberRole as string]} />
        })),
    [members]
  );

  return (
    <div className={styles.pending}>
      <Table
        columns={columnsNonMembers}
        data={transformedMembers}
        selectable
        sortable={false}
        searchBy="userId"
        actionButtons={ActionButtons}
        loading={loading}
      />
    </div>
  );
};

export default Pending;
